export default {
  sampleData: {},
};
